(function () {
  function safeParseJSONFromTextarea(el) {
    if (!el) return null;
    // In themes, textarea content is usually inside textContent, not value
    const raw = (el.value && el.value.trim()) ? el.value : el.textContent;
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function formatMoneyFromShopify(cents, moneyFormat) {
    // Handles common Shopify formats: {{amount}}, {{amount_no_decimals}}, {{amount_with_currency}}, etc.
    const amount = (cents / 100).toFixed(2);
    const noDecimals = String(Math.round(cents / 100));

    // currency symbol is already inside moneyFormat typically, so just replace tokens
    return (moneyFormat || "£{{amount}}")
      .replace("{{amount}}", amount)
      .replace("{{amount_no_decimals}}", noDecimals)
      .replace("{{amount_with_currency}}", amount) // fallback
      .replace("{{amount_with_comma_separator}}", amount.replace(".", ","))
      .replace("{{amount_no_decimals_with_comma_separator}}", noDecimals.replace(".", ","));
  }

  function initOneSection(root) {
    const cfg = window.__PAY_WIDGET__ || {};
    const moneyFormat = cfg.moneyFormat || "£{{amount}}";

    const variantTextarea = root.querySelector("[data-variant-json]");
    const variants = safeParseJSONFromTextarea(variantTextarea) || [];

    function findPriceByVariantId(variantId) {
      const v = variants.find(x => String(x.id) === String(variantId));
      return (v && typeof v.price === "number") ? v.price : null;
    }

    function setAmounts(priceCents) {
      if (typeof priceCents !== "number") return;

      const klarnaCents = Math.round(priceCents / 3);
      const clearpayCents = Math.round(priceCents / 4);

      root.querySelectorAll("[data-klarna-amount]").forEach(el => {
        el.textContent = formatMoneyFromShopify(klarnaCents, moneyFormat);
      });

      root.querySelectorAll("[data-clearpay-amount]").forEach(el => {
        el.textContent = formatMoneyFromShopify(clearpayCents, moneyFormat);
      });
    }

    function openModal(name) {
      root.querySelectorAll("[data-pay-modal]").forEach(m => (m.hidden = true));
      const modal = root.querySelector(`[data-pay-modal="${name}"]`);
      if (modal) modal.hidden = false;
    }

    function closeModals() {
      root.querySelectorAll("[data-pay-modal]").forEach(m => (m.hidden = true));
    }

    // Initial price from window config if available, otherwise from current variant json
    const initialPrice = cfg.initialVariantPrice;
    if (typeof initialPrice === "number") setAmounts(initialPrice);
    else {
      // fallback: if [name="id"] exists, compute from variants list
      const idInput = root.querySelector('[name="id"]') || document.querySelector('[name="id"]');
      const price = idInput ? findPriceByVariantId(idInput.value) : null;
      if (typeof price === "number") setAmounts(price);
    }

    // Click handlers (scoped)
    root.addEventListener("click", (e) => {
      const learn = e.target.closest("[data-pay-learn]");
      if (learn) openModal("chooser");

      const open = e.target.closest("[data-pay-open]");
      if (open) openModal(open.getAttribute("data-pay-open"));

      const close = e.target.closest("[data-pay-close]");
      if (close) closeModals();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeModals();
    });

    // Variant change: Motion/Archetype themes can use these
    const variantEvents = ["variant:change", "variant:changed", "product:variant-change"];
    variantEvents.forEach(evt => {
      document.addEventListener(evt, (e) => {
        const price = e?.detail?.variant?.price;
        if (typeof price === "number") setAmounts(price);
      });
    });

    // Fallback: observe [name="id"] changes inside this product form
    const variantIdInput = root.querySelector('[name="id"]') || document.querySelector('[name="id"]');
    if (variantIdInput) {
      variantIdInput.addEventListener("change", () => {
        const price = findPriceByVariantId(variantIdInput.value);
        if (typeof price === "number") setAmounts(price);
      });

      // Last resort poll (keeps it working even if theme updates value without firing change)
      let last = variantIdInput.value;
      setInterval(() => {
        if (variantIdInput.value !== last) {
          last = variantIdInput.value;
          const price = findPriceByVariantId(last);
          if (typeof price === "number") setAmounts(price);
        }
      }, 400);
    }
  }

  function boot() {
    // init per product section (prevents clashes if modal product is present)
    document.querySelectorAll(".product-section").forEach(section => {
      if (section.querySelector("[data-pay-widget]")) initOneSection(section);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
